import { AlertTriangle } from './icons';
export const ConfirmModal = ({ msg, onOk, onCancel, c }) => (
  <div style={{
    position: "fixed", inset: 0, zIndex: 100, display: "flex",
    alignItems: "center", justifyContent: "center",
    background: "rgba(0,0,0,0.5)", backdropFilter: "blur(8px)",
  }} onClick={onCancel}>
    <div onClick={(e) => e.stopPropagation()} style={{
      background: c.card, borderRadius: 16, padding: 28,
      maxWidth: 360, width: "90%", boxShadow: "0 24px 80px rgba(0,0,0,0.3)",
      border: "1px solid " + c.border,
      animation: "fadeSlideUp 0.25s cubic-bezier(0.25,0.1,0.25,1) both",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
        <AlertTriangle size={20} color={c.orange} />
        <span style={{ fontSize: 16, fontWeight: 700, color: c.fg }}>Confirm</span>
      </div>
      <p style={{ fontSize: 14, color: c.muted, lineHeight: 1.5, marginBottom: 24 }}>{msg}</p>
      <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
        <button onClick={onCancel} style={{
          padding: "8px 20px", borderRadius: 10, border: "1px solid " + c.border,
          background: "transparent", color: c.fg, fontSize: 13, fontWeight: 600, cursor: "pointer",
        }}>Cancel</button>
        <button onClick={onOk} style={{
          padding: "8px 20px", borderRadius: 10, border: "none",
          background: c.red, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer",
        }}>Confirm</button>
      </div>
    </div>
  </div>
);
